import { graphql } from "@/lib/gql/__generated__";

export const PlanI18nArticleUpdate_DesignPage_Mutation = graphql(`
	mutation PlanI18nArticleUpdate_DesignPage($input: PlanI18nArticleInput!) {
		planI18nArticleUpdate(input: $input) {
			userErrors
			planI18n {
				id
				lang
				hotelID
				planID
				name
				mainTarget
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				emailTemplateReservation {
					atCreated
					atUpdated
					atCanceled
					atCin
				}
				questions {
					questionID
					required
					questionType
					question
					options
				}
			}
		}
	}
`);
